<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="transparent"
        phoneHeaderFixed
        phoneBodyOverflowHidden
      >
        <div class="slot">
          <div class="details-container">
            <div class="banner prev-upload">
              <div
                class="upload-img"
                v-if="uploadedDetailList.length"
                @click="toggleShowDetail"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>

              <div
                class="empty"
                style="margin-top:60px; font-size: 12px"
                v-if="!uploadedDetailList.length"
              >
                还没有轮播组图立即
                <el-button type="primary" @click="toggleShowDetail" size="mini"
                  >添加</el-button
                >
              </div>
              <el-carousel height="196px" v-if="uploadedDetailList.length">
                <el-carousel-item v-for="(v, i) in uploadedDetailList" :key="i">
                  <div class="img-wrapper">
                    <img :src="v" alt="列表详情图" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="card">
              <div class="share" open-type="share">
                <img
                  src="https://imgcdn.hemiao100.com/mall/psef180a04759ad09c-a8bc-4402-897c-aa1f39b36a10.png"
                  alt="分享"
                />
              </div>
              <h3 class="activity-name">{{ ruleForm.actName }}</h3>
              <div class="flex item-center">
                <div class="price-box flex" v-if="ruleForm.round.length">
                  <template
                    v-if="
                      !ruleForm.round[0].subscribeRound[0].actCostMoney &&
                        !ruleForm.round[0].subscribeRound[0].actCostIntegral
                    "
                  >
                    <strong class="price">免费</strong>
                  </template>
                  <template v-else>
                    <strong
                      class="price "
                      v-if="ruleForm.round[0].subscribeRound[0].actCostMoney"
                      ><span class="currence-symbol">￥</span
                      >{{ ruleForm.round[0].subscribeRound[0].actCostMoney }}
                      <span>起</span>
                    </strong>
                    <strong
                      class="price"
                      v-if="ruleForm.round[0].subscribeRound[0].actCostIntegral"
                    >
                      <span>+</span>
                      {{
                        ruleForm.round[0].subscribeRound[0].actCostIntegral
                      }}积分</strong
                    >
                  </template>
                </div>
                <div class="for-people flex item-center">
                  适合人群：{{ ruleForm.suitPerson || "" }}
                </div>
              </div>
              <div
                class="activity-status"
                v-if="
                  ruleForm.timeStatus === 'notStart' ||
                    ruleForm.timeStatus === 'running'
                "
              >
                <div
                  class="count-down-wrapper flex item-center"
                  :class="ruleForm.timeStatus"
                >
                  <div>
                    <span
                      class="status"
                      v-if="ruleForm.timeStatus === 'notStart'"
                      >未开始</span
                    >
                    <span
                      class="status"
                      v-if="ruleForm.timeStatus === 'running'"
                      >报名中</span
                    >
                  </div>
                  <div class="line"></div>
                  <div class="flex">
                    距离报名
                    <span v-if="ruleForm.timeStatus === 'notStart'">开始</span>
                    <span v-if="ruleForm.timeStatus === 'running'">结束</span>
                    ：<count-down
                      blockBg="#000"
                      color="#fff"
                      v-if="endTime"
                      @timeUp="timeUp"
                      :endTime="endTime"
                      block
                    ></count-down>
                  </div>
                </div>
              </div>
              <div
                class="apply-wrapper flex flex-between item-center"
                v-if="ruleForm.timeStatus !== 'notStart'"
              >
                <span>已有{{ ruleForm.actMemberUpperLimitFalse }}人报名</span>
                <div class="avatar-list">
                  <img
                    class="image"
                    :src="v"
                    v-for="(v, i) in avatarList"
                    :key="i"
                    mode=""
                  />
                </div>
              </div>
              <div class="time-and-address ">
                <div
                  class="time item flex item-center prev-upload"
                  style="color: #F72B2B"
                >
                  <div
                    class="upload-img "
                    @click="addTime('activityDatePicker')"
                  >
                    <span
                      class="hmicon icon-shangchuantupian1 icon-hao pointer"
                    ></span>
                  </div>
                  活动日期：
                  <template
                    v-if="ruleForm.activityDate && ruleForm.activityDate.length"
                  >
                    <span>{{ ruleForm.activityDate[0] }}</span
                    >至 <span>{{ ruleForm.activityDate[1] }}</span>
                  </template>
                </div>
                <div class="time item flex item-center prev-upload">
                  <div class="upload-img " @click="addTime('applyDatePicker')">
                    <span
                      class="hmicon icon-shangchuantupian1 icon-hao pointer"
                    ></span>
                  </div>
                  报名时间：
                  <template
                    v-if="ruleForm.applyDate && ruleForm.applyDate.length"
                  >
                    <span>{{ ruleForm.applyDate[0] }}</span
                    >至 <span>{{ ruleForm.applyDate[1] }}</span>
                  </template>
                </div>
                <div class="adress item flex item-center">
                  地点：{{ ruleForm.actAddress || "" }}
                </div>
                <div class="detail item flex item-center">
                  活动人数：{{
                    ruleForm.actMemberUpperLimit +
                      ruleForm.actMemberUpperLimitFalse || 0
                  }}
                </div>
                <!-- <div class="detail  item flex item-center" v-if="ruleForm.timeStatus !== 'notStart'">报名人数：{{ruleForm.registeredAmount + ruleForm.actMemberUpperLimitFalse }}
						/
						{{(ruleForm.actMemberUpperLimitFalse + ruleForm.actMemberUpperLimit) || 0}}</div> -->
              </div>
            </div>
            <div class="rich-text-container">
              <div class="rich-text-header flex flex-center item-center">
                <span class="line"></span>
                <h3 class="text-center caption">
                  <span>活动介绍</span>
                </h3>
                <span class="line"></span>
              </div>
              <div class="rich-text">
                <div class="ql-container ql-snow" style="border: none">
                  <div class="ql-editor">
                    <div v-html="ruleForm.actDesc"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="concat-us-wrapper">
              <div open-type="contact" class="contact-button">
                <span class="hmicon icon-kefu"></span>
                <span>联系客服</span>
              </div>
            </div>
            <div class="footer flex flex-center item-center">
              <button
                class="btn round primary active"
                @click="toApply"
                v-if="
                  ruleForm.actMemberUpperLimit > ruleForm.registeredAmount &&
                    ruleForm.timeStatus === 'running'
                "
              >
                我要报名
              </button>
              <button
                class="btn round disabled"
                v-if="
                  ruleForm.actMemberUpperLimit > ruleForm.registeredAmount &&
                    ruleForm.timeStatus === 'notStart'
                "
              >
                未开始
              </button>
              <button
                class="btn round disabled"
                v-if="
                  ruleForm.actMemberUpperLimit > ruleForm.registeredAmount &&
                    ruleForm.timeStatus === 'end'
                "
              >
                已结束
              </button>
              <button
                class="btn round disabled"
                v-if="
                  ruleForm.actMemberUpperLimit === ruleForm.registeredAmount
                "
              >
                已约满
              </button>
            </div>
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="product-ruleForm"
        >
          <el-form-item label="活动名称：" prop="actName">
            <el-input
              size="small"
              style="width: 400px"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.actName"
              placeholder="请输入活动名称(30字以内)"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="活动标签："
            prop="activityLabel"
            v-if="activityLabel.length"
          >
            <el-select
              size="small"
              style="width:400px"
              clearable
              placeholder="请选择活动标签"
              v-model="ruleForm.activityLabel"
            >
              <el-option
                :label="v.itemText"
                :value="v.itemValue"
                v-for="(v, i) in activityLabel"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="活动日期：" prop="activityDate">
            <!-- <el-date-picker
              v-model="ruleForm.activityDate"
              type="datetimerange"
              align="right"
              ref="activityDatePicker"
              :picker-options="pickerOptions"
              start-placeholder="活动开始时间"
              end-placeholder="活动结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              size="small"
              class="mr10"
            ></el-date-picker> -->
            <div>
              开始时间：
              <el-date-picker
                disabled
                v-model="ruleForm.actStartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                placeholder="开始时间"
                size="small"
                class="mr10"
              >
              </el-date-picker>
            </div>

            <div>
              结束时间：
              <el-date-picker
                size="small"
                :editable="false"
                v-model="ruleForm.actEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="'23:59:59'"
                placeholder="结束时间"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="报名时间：" prop="applyDate">
            <!-- <el-date-picker
              v-model="ruleForm.applyDate"
              type="datetimerange"
              align="right"
              ref="applyDatePicker"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              start-placeholder="报名开始时间"
              end-placeholder="报名结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker> -->
            <div>
              开始时间：
              <el-date-picker
                disabled
                v-model="ruleForm.applyStartTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                placeholder="开始时间"
                size="small"
                class="mr10"
              >
              </el-date-picker>
            </div>

            <div>
              结束时间：
              <el-date-picker
                size="small"
                :editable="false"
                v-model="ruleForm.applyEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                placeholder="结束时间"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </el-form-item>
           <el-form-item label="指定区域" prop="regionCodeList">
            <div class="areipt">
                <el-cascader
                  clearable
                  class="mr10 "
                  ref="cascader"
                  v-model="queryAreaCodeRegion"
                  :props="queryProps"
                  :options="area"
                  @change="changeAddressCode"
                  show-all-levels
                  :change-on-select="false"
                  filterable
                  size="small"
                  placeholder="请选择区域"
                >
               </el-cascader>
            </div>
         
           </el-form-item>
          <el-form-item label="活动地点：" prop="actAddress">
            <el-input
              size="small"
              clearable
              maxlength="20"
              class="mr10 ipt"
              style="width:320px"
              v-model.trim="ruleForm.actAddress"
              placeholder="请选择活动地点"
            ></el-input>
            <el-button type="primary" size="small" @click="showMapDialog = true">
              选择地点
            </el-button>
            <div class="form-item-tip">
              （活动举行地点范围，例如武汉，手动输入地址无法导航，需要导航请选择地点）
            </div>
            <div class="flex flex-wrap mt10">
              <div class="flex flex-end mr10">详细地址</div>
              <el-input
                type="textarea"
                style="width: 400px"
                clearable
                v-model="ruleForm.actDetailAddress"
                size="small"
                placeholder="请输入详细地址"
              ></el-input>
            </div>
          </el-form-item>
          <!-- 地图选点弹框 -->
          <el-dialog
            title="选择活动地点"
            :visible.sync="showMapDialog"
            width="650px"
            :close-on-click-modal="false"
            custom-class="map-dialog"
          >
            <div v-if="showMapDialog" class="map-container">
              <map-picker
                :visible="showMapDialog"
                height="500px"
                width="100%"
                @locationSelect="handleLocationSelect"
              />
            </div>
          </el-dialog>
          <el-form-item label="适合人群：" prop="suitPerson">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              style="width:400px"
              v-model.trim="ruleForm.suitPerson"
              placeholder="请输入适合项目的人群/年龄"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动人数上限：" prop="actMemberUpperLimit">
            <el-input
              size="small"
              clearable
              type="number"
              style="width:400px"
              @mousewheel.prevent.native
              class="mr10 ipt"
              v-model.number="ruleForm.actMemberUpperLimit"
              placeholder="请输入活动人数上限，用于手机端显示"
            ></el-input>
          </el-form-item>
          <el-form-item label="虚拟报名人数：" prop="actMemberUpperLimitFalse">
            <!-- disabled -->
            <el-input              
              size="small"
              type="number"
              clearable
              style="width:400px"
              @mousewheel.prevent.native
              class="mr10 ipt"
              v-model.number="ruleForm.actMemberUpperLimitFalse"
              placeholder="虚拟报名人数，在实际报名人数上进行增加，促进客户参与度"
            ></el-input>
            <span
              v-if="
                ruleForm.actMemberUpperLimitFalse !== '' &&
                  ruleForm.actMemberUpperLimit !== ''
              "
            >
              {{ ruleForm.actMemberUpperLimitFalse }}/{{
                ruleForm.actMemberUpperLimit + ruleForm.actMemberUpperLimitFalse
              }}
            </span>
          </el-form-item>
          <el-form-item label="活动地点：" prop="actSite">
            <div class="location-list">
              <div
                class="location-item"
                v-for="(item, index) in ruleForm.round"
                :key="index"
              >
                <div v-if="!item.hidden">
                  <div>
                    <!-- <el-radio-group v-model="item.actAddressType" @change="actAddressTypeChange(item)">
                      <el-radio label="address">输入活动地点名</el-radio>
                      <el-radio label="shop">选择门店</el-radio>
                    </el-radio-group> -->
                    输入活动地点名
                  </div>
                  <div class="event-adress">
                    <el-input
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="item.actSite"
                      maxlength="20"
                      placeholder="请输入活动地点"
                    ></el-input>

                    
                    <el-button
                      type="primary"
                      v-if="index === 0"
                      @click="addLocationItem"
                      size="mini"
                      icon="hmicon icon-hao"
                      circle
                    ></el-button>
                    <el-button
                      type="warning"
                      v-else
                      @click="deleteCurrentLocation(index,item)"
                      size="mini"
                      icon="hmicon icon-jianhao"
                      circle
                    ></el-button>
                    <el-select
                      size="small"
                      style="width:300px"
                      placeholder="选择报名支付模式"
                      v-model="item.costType"
                      class="ml10"
                    >
                      <el-option
                        label="二选一支付（积分支付或者货币支付）"
                        value="either"
                      ></el-option>
                      <el-option
                        label="同时支付（积分加货币同时支付）"
                        value="both"
                      ></el-option>
                    </el-select>
                  </div>
                  <!-- 选择门店 -->
                    <store-selector
                      :store-list="item.actShopList || []"
                      :all-stores="allAvailableStores"
                      :store-code="storeCode"
                      :store-type.sync="item.actShopType"
                      @add-stores="(stores) => handleAddStores(item, stores)"
                      @delete-store="(store) => handleDeleteStore(item, store)"
                      @clear-all-stores="handleClearAllStores(item)"
                    />
                  <div class="form-item-tip">
                    （场次地址，例如武昌，汉口，汉阳）
                  </div>
                  <div class="event-details-table">
                    <div class="table-header flex">
                      <div class="flex-1 title">
                        活动场次
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                        >
                          <div>
                            比如，上午场（10:00-11:00），下午场(14:00-15:00）
                          </div>
                          <span slot="reference">
                            <i class="el-icon-question" style="fontSize:20px"></i>
                          </span>
                        </el-popover>
                      </div>
                      <div class="flex-1 title">场次人数上限</div>
                      <div class="flex-2 title actCostMoney">
                        活动费用

                        <span class="tip">(积分和金额都为0表示免费)</span>
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                        >
                          <div>
                            积分为0表示为只支持货币支付
                          </div>
                          <div>
                            货币为0表示为只支持积分支付
                          </div>
                          <span slot="reference">
                            <i class="el-icon-question" style="fontSize:20px"></i>
                          </span>
                        </el-popover>
                      </div>
                    </div>
                    <div class="table-body">
                      <draggable :list="item.subscribeRound">
                      <div
                        class="activity-item flex table-row"
                        v-for="(v, i) in item.subscribeRound"
                        :key="i"
                      >
                        <div class="flex-1 ipt-wrapper flex flex-center" v-if="!v.hidden">
                          <el-input
                            clearable
                            size="small"
                            v-model="v.actRound"
                            maxlength="20"
                            placeholder="活动场次"
                          />
                        </div>
                        <div class="flex-1 ipt-wrapper flex flex-center" v-if="!v.hidden">
                          <el-input
                            type="number"
                            clearable
                            size="small"
                            placeholder="场次人数上限"
                            @mousewheel.prevent.native
                            v-model.number="v.onceActMemberUpperLimit"
                          />
                        </div>
                        <div class="flex-2 ipt-wrapper flex flex-between" v-if="!v.hidden">
                          <div class="flex flex-1">
                            <el-input
                              type="number"
                              placeholder="报名金额"
                              @mousewheel.prevent.native
                              clearable
                              class="mr10"
                              size="small"
                              v-model="v.actCostMoney"
                            />{{ item.costType === "both" ? "加" : "或" }}
                            <el-input
                              type="number"
                              placeholder="建议报名积分大于100"
                              @input="filterInteger(v, 'actCostIntegral')"
                              @mousewheel.prevent.native
                              clearable
                              class="mr10 ml10"
                              size="small"
                              v-model.number="v.actCostIntegral"
                            />
                          </div>
                          <div>
                            <el-button
                              type="primary"
                              @click="addActivityItem(index)"
                              size="mini"
                              v-if="i === 0"
                              icon="hmicon icon-hao"
                              circle
                            ></el-button>
                            <el-button
                              type="warning"
                              v-else
                              @click="deleteCurrentActivity(index, i,v)"
                              size="mini"
                              icon="hmicon icon-jianhao"
                              circle
                            ></el-button>
                          </div>
                        </div>
                      </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="报名表单：" prop="formStatus">
            <el-radio-group disabled v-model="ruleForm.formStatus">
              <el-radio label="open">开启</el-radio>
              <el-radio label="close">关闭</el-radio>
            </el-radio-group>
            <hm-form ref="hmform" v-if="ruleForm.formStatus === 'open'">
            </hm-form>
          </el-form-item>
          <el-form-item label="关联发券：" prop="">
            <span class="form-red">
              (请先设置优惠券发放规则)
            </span>
            <div>
              分享发券
              <el-select
                clearable
                v-model="ruleForm.shareCouponRuleIds"
                placeholder="选择券包(可多选)"
                multiple
                size="small"
                filterable
                class="ml10 multiple-select"
              >
                <el-option
                  v-for="item in shareCouponList"
                  :key="item.couponSendId"
                  :label="item.name"
                  :value="item.couponSendId"
                ></el-option>
              </el-select>
            </div>
            <div>
              购买发券
              <el-select
                clearable
                v-model="ruleForm.buyCouponRuleIds"
                placeholder="选择券包(可多选)"
                multiple
                size="small"
                filterable
                class="ml10 multiple-select"
              >
                <el-option
                  v-for="item in buyCouponList"
                  :key="item.couponSendId"
                  :label="item.name"
                  :value="item.couponSendId"
                ></el-option>
              </el-select>
            </div>
            <div>
              核销发券
              <el-select
                clearable
                v-model="ruleForm.checkCouponRuleIds"
                placeholder="选择券包(可多选)"
                multiple
                size="small"
                filterable
                class="ml10 multiple-select"
              >
                <el-option
                  v-for="item in checkCouponList"
                  :key="item.couponSendId"
                  :label="item.name"
                  :value="item.couponSendId"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="主图：" prop="mainImgUrl">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              noCircle
              noSquare
              :width="300"
              :height="240"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mall' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              v-show="!listHeaderImgUrl"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip"
              >（主图仅可设置一张，图片尺寸建议300x240）</span
            >
            <div class="priview" v-if="listHeaderImgUrl">
              <img :src="listHeaderImgUrl" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="轮播组图：" prop="listDetail">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="showDetail"
              noCircle
              noSquare
              :width="750"
              :height="390"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              v-show="uploadedDetailList.length < 6"
              @click="toggleShowDetail"
              >上传</el-button
            >
            <span class="form-tip"
              >（列表详情图可设置6张，图片尺寸建议750x390）</span
            >
            <ul class="flex flex-wrap">
              <li
                class="priview mr10"
                v-show="v"
                v-for="(v, i) in uploadedDetailList"
                :key="i"
              >
                <img :src="v" alt="列表详情图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="setFirst(i)"
                    >设为第一张图</el-button
                  >
                  <el-button type="text" @click="handleRemoveListDetail(i)"
                    >删除</el-button
                  >
                </div>
              </li>
            </ul>
          </el-form-item>
          <el-form-item label="图文详情：" prop="actDesc">
            <div style="color: red;font-weight: bold">详情内若有图片，请上传图片，不要直接复制或者拖拽图片，这样有可能导致手机端图文无法正常显示</div>
            <hm-rich-editor
              v-model="ruleForm.actDesc"
              :html="ruleForm.actDesc"
            />
          </el-form-item>
          <el-form-item label="活动状态：">
            <el-switch
              v-model="ruleForm.actStatus"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <el-form-item label="是否显示活动：">
            <el-switch
              v-model="ruleForm.isShow"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="显示"
              inactive-text="隐藏"
              active-value="yes"
              inactive-value="no"
            ></el-switch>
          </el-form-item>
          <div class="flex flex-center">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";
import { compare } from "@/utils/utils";
import HmRichEditor from "@/components/HmRichEditor";
import HmForm from "@/components/HmForm";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import area from "@/utils/area";
import StoreSelector from "@/components/store-selector/StoreSelector";
import MapPicker from "@/components/MapPicker/MapPicker";
export default {
  components: { myUpload, HmRichEditor, HmForm, actPreview, draggable, StoreSelector, MapPicker },
  data() {
    const patternApplyDate = (rule, val, callback) => {
      if (!compare(this.ruleForm.actEndTime, this.ruleForm.applyEndTime)) {
        return callback(new Error("活动报名时间应小于活动结束时间"));
      }
      callback();
    };
    const patternActivityDate = (rule, val, callback) => {
      this.$refs.ruleForm.validateField("applyDate");
      callback();
    };
    const patternFormStatus = (rule, val, callback) => {
      if (val === "open") {
        if (this.$refs.hmform.list.length === 0) {
          return callback(new Error("请选择表单"));
        } else {
          let flag = false;
          this.$refs.hmform.list.forEach(v => {
            if (v.columnValue === "") {
              flag = true;
            }
            if (v.columnType === "radio") {
              v.paramInfoModels.forEach(o => {
                if (o.columnValue === "") {
                  flag = true;
                }
              });
            }
          });
          if (flag) {
            return callback(new Error("请把表单填写完整"));
          }
        }
      }
      callback();
    };
    const patternListHeader = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    const patternListDetail = function(rule, val, callback) {
      if (this.uploadedDetailList.length <= 0) {
        return callback(new Error("请上传列表详情图"));
      }
      callback();
    }.bind(this);
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;
      let haveEmptyConditionBoth = false;
      let haveEmptyShopName = false;
      this.ruleForm.round.map(o => {
        if (!o.actSite || !o.costType) {
          haveEmptyCondition = true;
        }
        // 验证门店选择：actShopName 为必填项
        if (!o.actShopName || (Array.isArray(o.actShopName) && o.actShopName.length === 0)) {
          haveEmptyShopName = true;
        }
        o.subscribeRound.map(v => {
          for (let key in v) {
            if (v[key] === "" && v.hidden==false) {
              haveEmptyCondition = true;
            }
          }
        });
        if(o.costType==="both"){
          o.subscribeRound.map(v => {
            if ((v.actCostMoney <= 0 || v.actCostIntegral <= 0 ) && v.hidden == false) {
              haveEmptyConditionBoth = true;
            }
          })
        }
      });
      if (haveEmptyShopName) {
        return callback(new Error("请选择门店"));
      }
      if (haveEmptyCondition) {
        return callback(new Error("请填写完所有项"));
      }
      if (haveEmptyConditionBoth){
        return callback(new Error("同时支付模式,报名金额或积分不能小于等于0"));
      }
      callback();
    }.bind(this);
    const patternRegisteredAmountFunc = function(rule, val, callback) {
      if (val > +this.ruleForm.actMemberUpperLimit) {
        return callback(new Error("已报名人数不能大于活动人数上限"));
      }
      callback();
    }.bind(this);
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      activityLabel: [],
      buyCouponList: [],
      shareCouponList: [],
      checkCouponList: [],
      showDetail: false,
      show: false,
      showMapDialog: false,
      inputVisible: false,
      isMininum: true,
      activityDate: "",
      inputValue: "",
      activeTab: 0,
      type: 0,
      avatarList: [
        "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83erhhic8hpR2l4WqcPdF3qjx0ldiaGoAEsmHd6WB3vE8kWqTu3utIaP2xz0CPJNhV80w7ECga8NHg3dA/132",
        "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTLSqaj1JPOJkNH2vuiaIj1W2Rw8NJNwmO5VleBIZUe5Z89oA9fH9qnmS1YicvscwDLbHvLHYeAg7wDQ/132",
        "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTK8C9x86FTYTxibmTOpyslBDlkc1SzJ1XLozIpp51ANQD7cYOicPEDyibY1Gtiaibpb39JUEfcfAncTiaYw/132",
        "https://wx.qlogo.cn/mmopen/vi_32/aCicaoUBEugibPOuQPYaaT8sMcbWx9IGaCTj1R8U4AFxj6CsOUE2n1682A0UxGmiaBFrxbyg5WIMtHVibib5XskWOibQ/132",
        "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJ8Jt0T0AgGWgoZgT8bMicF6wgKJUBbc82UtNibhtWn4pibKZruc4RyljLlzMjaiaE8DQtzEicRNU51VfA/132"
      ],
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      startDate: "",
      validDate: "",
      editorOption: {},
      chargeType: "",
      actAddress:"",
      actDetailAddress:"",
      ruleForm: {
        actName: "",
        activityLabel: "",
        actCostIntegral: "",
        actStatus: 1,
        actCostMoney: "",
        actStartTime: "",
        actEndTime: "",
        applyStartTime: "",
        applyEndTime: "",
        round: [
          {
            actSite: "",
            actShopName: "",
            actShopList: [],
            actShopType: "self",
            costType: "",
            subscribeRound: [
              {
                activitySession: "",
                onceActMemberUpperLimit: "",
                costType: false,
                costTypeM: false,
                actCostIntegral: ""
              }
            ]
          }
        ],
        activityDate: [],
        applyDate: [],
        actAddress: "",
        actDetailAddress:"",
        longitude:"",
        latitude:"",
        suitPerson: "",
        actDesc: "",
        actMemberUpperLimitFalse: 0,
        actMemberUpperLimit: 0,
        formStatus: "",
        shareCouponRuleIds: [],
        buyCouponRuleIds: [],
        checkCouponRuleIds: [],
      },
      rules: {
        actName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 2, message: "长度不能小于2个字符", trigger: "blur" }
        ],
        activityLabel: {
          required: true,
          message: "请选择活动标签",
          trigger: "blur"
        },
        formStatus: [
          {
            required: true,
            message: "请选择表单状态",
            trigger: "blur"
          },
          { required: true, validator: patternFormStatus, trigger: "change" }
        ],
        actAddress: [
          { required: true, message: "请选择活动名称", trigger: "blur" }
        ],
        activityDate: [
          { required: true, message: "请输入活动时间", trigger: "change" },
          { required: true, validator: patternActivityDate, trigger: "change" }
        ],
        actCostIntegral: [
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入大于等于0的正整数"));
              }
            },
            trigger: "blur"
          }
        ],
        suitPerson: [
          { required: true, message: "请输入适合人群/年龄", trigger: "blur" }
        ],
        applyDate: [
          { required: true, message: "请输入报名时间", trigger: "change" },
          { required: true, validator: patternApplyDate, trigger: "change" }
        ],
        actDesc: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        actSite: [
          { required: true, validator: patternLocation, trigger: "blur" }
        ],
        actMemberUpperLimitFalse: [
          { required: true, message: "请输入报名人数", trigger: "blur" },
          {
            validator: patternRegisteredAmountFunc,
            trigger: "blur"
          }
        ],
        actMemberUpperLimit: [
          { required: true, message: "请输入活动人数上限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number.isInteger(Number(value)) && Number(value) >= 0) {
                callback();
              } else {
                callback(new Error("请输入大于等于0的正整数"));
              }
            },
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
        listDetail: [
          {
            required: true,
            validator: patternListDetail,
            trigger: "blur"
          }
        ]
      },
      storeCode: "",
      queryProps: {
        multiple: true,
        value: "value",
        label: "label",
        children: "children",
      },
      queryAreaCodeRegion: [],
      changeOnSelect: false,
      area,
    };
  },
  computed: {
    ...mapGetters(["storeStyle","microShopStoreList", "dkMicroShopStoreList"]),
    // 获取所有可用门店列表
      allAvailableStores() {
      const { storeCode } = getLoginUser();
      let stores = [];
      if (storeCode === '53010017032439' || storeCode === '42010216070190') {
        stores = this.dkMicroShopStoreList || [];
      } else {
        stores = this.microShopStoreList || [];
      }
      // 过滤掉 shopId 为 "直营店" 和 "加盟店" 的数据
      return stores.filter(store => store.shopId !== '直营店' && store.shopId !== '加盟店');
    }
  },
  watch: {
    // 监听门店列表变化，当门店列表加载完成后重新初始化门店数据
    allAvailableStores: {
      handler(newVal) {
        // 当有门店数据且 round 已加载时，重新初始化 actShopList
        if (newVal && newVal.length > 0 && this.ruleForm.round && this.ruleForm.round.length > 0) {
          this.initRoundShopList();
        }
      },
      immediate: false
    }
  },
  created() {
    this.queryBuyCouponList();
    this.queryShareCouponList();
    this.queryCheckCouponList();
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:",this.storeCode);
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    const { id } = this.$route.query;

    this.queryActivityLabel();
    this.$store
      .dispatch("subActivityDetails", {
        id
      })
      .then(res => {
        const result = res.result || {};
        if (res.code == 0) {
          // result.roundBo.forEach(o => {
          //   o.subscribeRound.reverse();
          // });

          for (let key in result) {
            if (this.ruleForm.hasOwnProperty(key)) {
              this.ruleForm[key] = result[key];
            }
          }

          this.ruleForm.activityDate = [result.actStartTime, result.actEndTime];
          this.ruleForm.shareCouponRuleIds = result.shareCouponRuleIds
            ? result.shareCouponRuleIds.split(";").map(o => o)
            : [];
          this.ruleForm.buyCouponRuleIds = result.buyCouponRuleIds
            ? result.buyCouponRuleIds.split(";").map(o => o)
            : [];
          this.ruleForm.checkCouponRuleIds = result.checkCouponRuleIds
            ? result.checkCouponRuleIds.split(";").map(o => o)
            : [];
          this.ruleForm.applyDate = [
            result.applyStartTime,
            result.applyEndTime
          ];
          console.log("this.ruleForm: ", this.ruleForm);
          this.ruleForm.actAddress = result.actSite;
          this.listHeaderImgUrl = result.mainImgUrl;

          // 处理round中的门店信息：将actShopName字符串转换为数组，并匹配完整的门店对象
          result.roundBo.forEach(v => {
            v.hidden = false;
            v.subscribeRound.forEach(o => {
              o.costType = !o.actCostIntegral ? "price" : "points";
              o.hidden = false;
              o.cost = !o.actCostIntegral ? o.actCostMoney : o.actCostIntegral;
            });

            // 兼容历史数据：根据actAddressType字段处理门店信息
            if (v.actAddressType) {
              // 历史数据有actAddressType字段
              if (v.actAddressType === 'shop') {
                // 门店类型：将actSite转换为门店数组
                if (v.actSite && typeof v.actSite === 'string') {
                  // 判断是否为"全部门店"
                  if (v.actSite === '全部门店') {
                    // 全部门店：选中所有门店
                    v.actShopName = this.allAvailableStores.map(store => store.shopName);
                  } else {
                    // 普通门店列表：按逗号分割
                    v.actShopName = v.actSite.split(',');
                  }
                } else {
                  v.actShopName = [];
                }
                v.actSite = ''; // 门店类型下清空actSite
              } else if (v.actAddressType === 'address') {
                // 地址类型：actSite保持不变，清空门店信息
                v.actShopName = [];
              }
            } else {
              // 新数据没有actAddressType字段，直接处理actShopName
              if (v.actShopName && typeof v.actShopName === 'string') {
                v.actShopName = v.actShopName.split(',');
              }
            }

          });

          this.ruleForm.round = result.roundBo;

          // 初始化场次门店列表（如果 allAvailableStores 已加载则直接初始化，否则由 watch 处理）
          this.initRoundShopList();

          setTimeout(() => {
            if (this.$refs.hmform) {
              this.$refs.hmform.list = result.columnsInfoModels;
            }
          }, 1000);
          this.uploadedDetailList = result.subscribeCarousel.map(
            v => v.carouselImgUrl
          );
          this.ruleForm.actStatus = +result.actStatus;

          // 处理区域数据，将后端返回的pasSubscribeActivityAddressRelModelList转换为queryAreaCodeRegion格式
          if (result.pasSubscribeActivityAddressRelModelList && result.pasSubscribeActivityAddressRelModelList.length > 0) {
            this.queryAreaCodeRegion = [];
            result.pasSubscribeActivityAddressRelModelList.forEach(cityData => {
              const { provinceCode, cityCode, districtCodeList } = cityData;
              // 将districtCodeList字符串分割成数组
              const districtCodes = districtCodeList.split(',');
              // 为每个区创建一个数组[省代码, 市代码, 区代码]
              districtCodes.forEach(districtCode => {
                this.queryAreaCodeRegion.push([provinceCode, cityCode, districtCode]);
              });
            });
          }
        }
      });
      
  },
  methods: {
    // 初始化场次门店列表（从 actShopName 匹配完整的门店对象）
    initRoundShopList() {
      this.ruleForm.round.forEach(v => {
        // 确保 actShopList 是响应式属性
        if (!v.actShopList) {
          this.$set(v, 'actShopList', []);
        }
        // 确保 actShopType 是响应式属性
        if (!v.actShopType) {
          this.$set(v, 'actShopType', 'self');
        }
        // 根据 shopName 从 allAvailableStores 中匹配完整的门店对象
        if (v.actShopName && Array.isArray(v.actShopName)) {
          v.actShopList = v.actShopName.map(shopName => {
            return this.allAvailableStores.find(store => store.shopName === shopName);
          }).filter(store => store !== undefined);
        }
      });
    },
    // 处理添加门店（完全替换，支持取消选择）
    handleAddStores(roundItem, newStores) {
      // 直接替换为新的商店列表
      this.$set(roundItem, 'actShopList', newStores || []);
      // 同步更新actShopName为门店名称数组（保持向后兼容）
      roundItem.actShopName = roundItem.actShopList.map(s => s.shopName);
    },
    // 处理删除门店
    handleDeleteStore(roundItem, store) {
      if (!roundItem.actShopList) return;

      const index = roundItem.actShopList.findIndex(s => s.shopName === store.shopName);
      if (index > -1) {
        roundItem.actShopList.splice(index, 1);
        // 同步更新actShopName
        roundItem.actShopName = roundItem.actShopList.map(s => s.shopName);
      }
    },
    // 处理清空所有门店
    handleClearAllStores(roundItem) {
      if (roundItem.actShopList) {
        roundItem.actShopList = [];
        roundItem.actShopName = [];
      }
    },
    handleLocationSelect(loc) {
      this.ruleForm.actAddress = loc.poiname;
      this.actAddress = loc.poiname;
      this.ruleForm.actDetailAddress = loc.poiaddress;
      this.actDetailAddress = loc.poiaddress;
      this.ruleForm.longitude = loc.longitude;
      this.ruleForm.latitude = loc.latitude;
      this.showMapDialog = false;
      this.$message({
        message: "地点选择成功",
        type: "success",
      });
    },
    async queryBuyCouponList() {
      const { result } = await this.$store.dispatch("queryCouponPackages", {
        couponType: "buy"
      });
      this.buyCouponList = result;
    },
    async queryShareCouponList() {
      const { result } = await this.$store.dispatch("queryCouponPackages", {
        couponType: "share"
      });
      this.shareCouponList = result;
    },
    async queryCheckCouponList() {
      const { result } = await this.$store.dispatch("queryCouponPackages", {
        couponType: "check"
      });
      this.checkCouponList = result;
    },
    addTime(type) {
      this.$refs[type].focus();
    },
    async queryActivityLabel() {
      const { result } = await this.$store.dispatch("queryActivityLabel");
      if (result && result.length) {
        this.activityLabel = result;
      }
    },
    filterRuleFormNegativeNumber(prop) {
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(/-/g, "")
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
    },
    filterPrice(v, prop) {
      if (v[prop]) {
        v[prop] = +String(v[prop])
          .replace(/-/g, "")
          .replace(/[^\d.]/g, "")
          .replace(/\.{2,}/g, ".")
          .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
      }
    },
    filterRuleFormInregral(prop) {
      this.ruleForm[prop] = String(this.ruleForm[prop]).replace(/-|\.|/g, "");
    },
    filterInteger(v, prop) {
      if (v[prop]) {
        v[prop] = +String(v[prop])
          .replace(/-/g, "")
          .replace(/\./g, "");
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    addLocationItem() {
      // let actAddressTypeTemp = "address";
      this.ruleForm.round.push({
        actAddress: "",
        // actAddressType: actAddressTypeTemp,
        actSite: "",
        actShopList: [],
        actShopType: "self",
        costType: "either",
        hidden: false,
        subscribeRound: [
          {
            actRound: "",
            onceActMemberUpperLimit: "",
            costType: "price",
            actCostIntegral: "",
            hidden: false,
          }
        ]
      });
    },
    deleteCurrentLocation(index,item) {
      let isHasSubscribeRound = false;
      item.subscribeRound.forEach(v=>{
        if(v.id){
          isHasSubscribeRound = true;
        }
      })
      if(isHasSubscribeRound){
        this.ruleForm.round[index].hidden = true;
      }else{
        this.ruleForm.round.splice(index, 1);
      }
      this.$forceUpdate();
    },
    addActivityItem(index) {
      this.ruleForm.round[index].subscribeRound.push({
        actRound: "",
        onceActMemberUpperLimit: "",
        costType: "price",
        actCostIntegral: "",
        actCostMoney: "",
        hidden: false,
      });
    },
    deleteCurrentActivity(index, i,v) {
      if(v.id){
        this.ruleForm.round[index].subscribeRound[i].hidden = true;
      }else{
        this.ruleForm.round[index].subscribeRound.splice(i, 1);
      }
      this.$forceUpdate();
    },
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    formatValidDate(type) {
      if (type === 0) {
        this.validDate = "不限时间";
      } else if (type === 1) {
        this.validDate = `购买后${this.ruleForm.validSpaceDay}天后生效，有效期${this.ruleForm.validDay}天`;
      } else if (type === 2) {
        const startDate = this.ruleForm.dateAndTime[0]
          ? moment(this.ruleForm.dateAndTime[0]).format("YYYY-MM-DD")
          : "";
        const endDate = this.ruleForm.dateAndTime[1]
          ? moment(this.ruleForm.dateAndTime[1]).format("YYYY-MM-DD")
          : "";
        this.validDate = `${startDate}-${endDate}`;
      }
    },
    minimum() {
      this.isMininum = !this.isMininum;
    },
    getChargeType(id) {
      this.chargeType = id
        ? this.serviceList.list.find(v => v.id === id).chargeType
        : "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.ruleForm.productTags.splice(
        this.ruleForm.productTags.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.productTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm(formName) {
      console.log("提交")
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.ruleForm.round.length>0){
            this.ruleForm.round.forEach(v=>{
              v.subscribeRound.forEach((o,index)=>{
                o.sort = index;
              })
              // 将actShopName数组转换为字符串（逗号分割）传给后端
              if (v.actShopName && Array.isArray(v.actShopName)) {
                v.actShopName = v.actShopName.join(',');
              }
              // 添加actShopType字段，默认为self
              v.actShopType = v.actShopType || 'self';
              // 添加actShopJson字段，包含shopId和shopName的JSON字符串
              if (v.actShopList && Array.isArray(v.actShopList) && v.actShopList.length > 0) {
                const shopJson = v.actShopList.map(store => ({
                  shopId: store.shopId,
                  shopName: store.shopName
                }));
                v.actShopJson = JSON.stringify(shopJson);
              } else {
                v.actShopJson = '[]';
              }
              // 删除actAddressType字段，新数据不传此字段
              delete v.actAddressType;
              // 删除actShopList字段，不传给后端
              delete v.actShopList;
            })
          }
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          // params.actStartTime = params.activityDate[0];
          // params.actEndTime = params.activityDate[1];
          // params.applyStartTime = params.applyDate[0];
          // params.applyEndTime = params.applyDate[1];
          params.actCostMoney = +params.actCostMoney;
          let columnsInfoModels = [];
          if (this.$refs.hmform) {
            columnsInfoModels = this.$refs.hmform.list;
          }
          params.shareCouponRuleIds = params.shareCouponRuleIds.join(";");
          params.buyCouponRuleIds = params.buyCouponRuleIds.join(";");
          params.checkCouponRuleIds = params.checkCouponRuleIds.join(";");
          params = Object.assign(params, {
            detailImg: this.uploadedDetailList.join(","),
            mainImgUrl: this.listHeaderImgUrl,
            productTags: this.ruleForm.productTags,
            userId: getLoginUser().userId,
            id: this.$route.query.id,
            columnsInfoModels
          });
          if (params.actAddress !== this.actAddress) {
            params.longitude = "";
            params.latitude = "";
          }

          this.$store.dispatch("editSubActivity", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.listHeaderImgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 345;
        let height = 180;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传345*180的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          v => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    setFirst(i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    },
    actAddressTypeChange(item){
      item.actSite = "";
    },
    changeAddressCode(val) {
      console.log(val);
      // 将选择的区域数据转换为所需的格式
      this.transformAddressData();
    },

    // 转换地址数据为所需格式
    transformAddressData() {
      // 创建一个映射，将城市代码映射到区代码列表
      const cityDistrictMap = {};

      // 遍历选择的区域码，每个选择项是一个数组，包含省市区代码
      this.queryAreaCodeRegion.forEach(selected => {
        if (selected && selected.length >= 3) {
          const provinceCode = selected[0]; // 省代码
          const cityCode = selected[1]; // 市代码
          const districtCode = selected[2]; // 区代码

          // 如果城市代码不存在于映射中，初始化
          if (!cityDistrictMap[cityCode]) {
            cityDistrictMap[cityCode] = {
              cityCode: cityCode,
              provinceCode: provinceCode,
              districtCodeList: []
            };
          }

          // 添加区代码到对应城市的区列表中
          cityDistrictMap[cityCode].districtCodeList.push(districtCode);
        }
      });

      // 将映射转换为所需的数据格式
      this.ruleForm.pasSubscribeActivityAddressRelModelList = [];
      for (const cityCode in cityDistrictMap) {
        const cityData = cityDistrictMap[cityCode];
        // 将区代码用逗号连接成字符串
        const districtCodeListStr = cityData.districtCodeList.join(',');
        this.ruleForm.pasSubscribeActivityAddressRelModelList.push({
          cityCode: cityData.cityCode,
          districtCodeList: districtCodeListStr,
          provinceCode: cityData.provinceCode
        });
      }

      console.log('转换后的地址数据:', this.ruleForm.pasSubscribeActivityAddressRelModelList);
    },
  }
};
</script>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}

.event-details-table {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  .table-header {
    background: #f7f7f7;
    padding: 0 10px;
    .title {
      text-align: center;
    }
  }
  .activity-item {
    padding: 0 10px;
    .ipt-wrapper {
      box-sizing: border-box;
      .el-input {
        width: 80%;
      }
    }
  }
}

.location-item:not(:last-child) {
  margin-bottom: 20px;
}

.cost {
  padding-left: 20px;
  .tip {
    color: #999;
  }
}

.event-adress {
  margin-bottom: 10px;
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .bg {
    height: 80px;
    background: linear-gradient(to bottom, #f73030, #f6c0c0, #f5f5f5);
    z-index: -1;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .slot {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 549px;
    overflow-y: auto;
    transform: scale(1);

    .header-img-wrapper {
      box-sizing: border-box;
      padding: 0 15px;
      .header-img {
        width: 345px;
        height: 130px;
        display: block;
        border-radius: 5px;
      }
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }
  }

  .details-container {
    .price {
      color: #f72b2b;
    }

    .concat-us-wrapper {
      position: fixed;
      right: 0;
      bottom: 100px;
      z-index: 999;
      height: 26px;
      line-height: 26px;
      border-radius: 30px 0 0 30px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      text-align: center;
      padding: 5px 10px;
      .contact-button {
        background: transparent;
        line-height: 26px;
        color: #fff;
        font-size: 12px;
        height: 100%;
        display: block;
      }
    }
    .banner {
      .upload-img {
        top: 60px;
      }
    }

    .card {
      position: relative;
      margin: 0;
      background: #fff;
      padding: 15px;
      line-height: 30px;
      font-size: 13px;
      .share {
        width: 85px;
        height: 85px;
        position: absolute;
        top: -42px;
        right: 0;
        background: transparent;
        padding: 0;
        margin: 0;
        z-index: 9999;

        img {
          width: 100%;
        }
      }
      .price-box {
        font-size: 18px;
        font-weight: bold;
        margin-right: 10px;
      }
      .time-and-address {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 5px;
        margin: 15px 0;
        font-size: 12px;
        .item {
          &::before {
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #656565;
            border-radius: 50%;
            margin-right: 8px;
            content: "";
          }
        }
      }

      .detail {
        font-size: 13px;

        &::before {
          content: "";
          display: inline-block;
          border-radius: 50%;
          width: 5px;
          height: 5px;
          margin-right: 5px;
          background: #666666;
        }
      }
    }

    .avatar-list {
      .image {
        width: 29px;
        height: 29px;
        border-radius: 50%;
        border: 1px solid #fff;
        margin: -4px;
      }
    }
    .activity-name {
      margin: 0;
    }

    .for-people {
      height: 16px;
      line-height: 16px;
      background: #ededed;
      border-radius: 3px;
      font-size: 11px;
      color: #656565;
      padding: 3px 5px;
    }

    .rich-text-container {
      margin: 15px 0 60px;
      background: #fff;

      .rich-text-header {
        padding: 20px;

        .line {
          background: #f72b2b;
          width: 20px;
          height: 3px;
          border-radius: 30px;

          &::after {
            display: block;
            content: "";
            background: #f72b2b;
            width: 20px;
            height: 3px;
            border-radius: 30px;
            transform: translate(5px, 5px);
          }
        }

        .caption {
          margin: 0 15px;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .rich-text {
        padding: 10px;
      }
    }

    .apply-wrapper {
      margin: 15px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .time {
      white-space: nowrap;
      // span {
      //   transform: scale(0.8);
      // }
    }
  }
}
.table-row:hover {
  cursor: move;
}
/deep/ .areipt .el-cascader .el-input  {
  width: 400px !important;
}
</style>
